<template>
  <app-modal
      :modal-id="modalId"
      :title="title"
      :preloader="preloader"
      @submit="submit"
      @close-modal="closeModal"
      modal-size="large"
      modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
          type="button"
          class="close outline-none"
          data-dismiss="modal"
          aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="
          selectedUrl
            ? `/masterData/activities/${inputs.id}`
            : `/masterData/activities`
        "
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="mb-0">
                {{ $t("accreditation_area") }}
              </label>
              <app-input
                  id="inputs_accreditation_area_id"
                  type="select"
                  v-model="inputs.accreditation_area_id"
                  :list="accreditationAreaList"
                  :required="true"
                  :disabled="inputs.can_edit == 0"
              />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label class="mb-0">Nombre</label>
              <app-input
                  type="text"
                  v-model="inputs.name"
                  placeholder="Ingrese Nombre del Áctividad"
                  :required="true"
                  :disabled="inputs.can_edit == 0"
              />

            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label> Tipo evaluador </label>
              <app-input
                  type="select"
                  v-model="inputs.evaluator_type"
                  :list="evaluatorTypes"
                  :required="true"
              />
            </div>
          </div>

          <div class="col-12" v-if="inputs.can_edit == 0">
            <app-note
                class="mb-primary"
                title="Información"
                content-type="html"
                :notes="[
                'No puedes editar el <b>Nombre</b> y <b>Área de Acreditación</b> de esta actividad debido a que <b>pertenece a una solicitud.</b>',
              ]"
            />
          </div>

        </div>
      </form>
    </template>

    <template slot="footer">
      <button
          type="button"
          class="btn btn-secondary mr-2"
          data-dismiss="modal"
          @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
    accreditationAreaList: Array,
  },
  data() {
    return {
      preloader: false,
      inputs: {
        rules: [],
        is_active: 0,
        can_edit: 1,
        application_name: "N/A",
        form_name: "N/A"
      },
      modalId: "evaluator-activities-modal-add-edit",
      isActive: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
      isRequest: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
      rulesList: [],
      evaluatorTypes: [
          {id: "", value: this.$t("select_option")},
          {id: 'E', value: 'Evaluador'},
          {id: 'ET', value: 'Experto Técnico'}
      ]
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
  },
  created() {
    this.getOptions();
    if (this.selectedUrl) {
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      this.save(this.inputs);
    },
    afterSuccess(response) {
      if (this.selectedUrl != "") {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
      this.preloader = false;
    },
    afterSuccessFromGetEditData(response) {
      const tmp = response.data;
      tmp.rules = tmp.rules.map((item) => item.selected_id);
      this.inputs = tmp;
      this.preloader = false;
    },
    afterFinalResponse() {
      this.closeModal();
      this.preloader = false;
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    getOptions() {
      let url = `/masterData/rulesAccreditation/getOptions`;
      this.axiosGet(url)
          .then((response) => {
            if (response.status == 200) {
              this.rulesList = response.data;
            }
          })
          .catch(({ error }) => {
            console.log(error);
          });
    },
  },
};
</script>
